// src/services/mesaService.js

// Cargar ordenes guardadas desde localStorage
export const loadOrdenes = () => {
  const guardadas = localStorage.getItem("ordenesPorMesa");
  return guardadas ? JSON.parse(guardadas) : {};
};

// Guardar ordenes en localStorage
export const saveOrdenes = (ordenesPorMesa) => {
  localStorage.setItem("ordenesPorMesa", JSON.stringify(ordenesPorMesa));
};

// Cargar mesa seleccionada
export const loadMesaSeleccionada = () => {
  const guardada = localStorage.getItem("mesaSeleccionada");
  return guardada ? Number(guardada) : null;
};

// Guardar mesa seleccionada
export const saveMesaSeleccionada = (mesaId) => {
  localStorage.setItem("mesaSeleccionada", mesaId);
};

// Limpiar mesa seleccionada
export const clearMesaSeleccionada = () => {
  localStorage.removeItem("mesaSeleccionada");
};
